import * as React from 'react';
import { TextField, PrimaryButton } from '@fluentui/react';
import axios from 'axios';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';

export class Password extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: '',
            confirmPass: '',
            errors: {},
            showSuccess: false,
            showError: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleConfirmPassChange = this.handleConfirmPassChange.bind(this);
    }

    handleSubmit(event) {
        this.setState({
            showError: false
        });
        let errors = {};
        event.preventDefault();
        if (!this.state.newPassword) {
            errors["newPassword"] = "New password is required.";
        }

        if (this.state.newPassword.length < 6) {
            errors["confirmPass"] = "Please create a password that’s just a bit longer (at least 6 characters).";
        }
        if (this.state.newPassword != this.state.confirmPass) {
            errors["confirmPass"] = "Passwords do not match!";
        }
        if (!this.state.confirmPass) {
            errors["confirmPass"] = "Please confirm password";
        }


        if (Object.keys(errors).length > 0) {
            this.setState({
                errors: errors,
                formIsValid: false
            });
            return;
        }


        var model = {
            Value: this.state.newPassword
        }

        axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdatePassword", model)
            .then((response) => {
                this.setState({
                    showSuccess: true,
                    newPassword: '',
                    confirmPass: '',
                });
            })
            .catch((error) => {
                
                if (error.response.data == "PasswordStrengthError: Password is too weak") {
                    this.setState({
                        showError: true
                    });
                }
            });
    }

    handleNewPasswordChange(event) {
        let errors = this.state.errors
        delete errors['newPassword'];
        this.setState({
            newPassword: event.target.value,
            errors: errors,
        });
    }
    handleConfirmPassChange(event) {
        let errors = this.state.errors
        delete errors['confirmPass'];
        this.setState({
            confirmPass: event.target.value,
            errors: errors,
        });
    }

    render() {
        return (

            <form id="ContactForm" name="ContactForm" className="default-form" style={{maxWidth:400}} noValidate="noValidate" autoComplete="off" onSubmit={this.handleSubmit}>
                {this.state.showError &&
                    <div className="alert alert-danger" style={{ 'margin': "5px 0px 0px" }}>
                        <strong>Error:</strong> {this.state.errorMessage}
                    </div>
                }
                {this.state.showSuccess && this.props.type == 'support' &&
                    <div className="alert alert-info" style={{ 'margin': "5px 0px 0px" }}>
                        <strong>Success!</strong> Someone will get back to your shortly.
                </div>
                }
                <div className="form-group pb10 ">
                    <label class="control-label">New Password</label>
                    <TextField type="password" className="form-control" 
                        value={this.state.newPassword}
                        onChange={this.handleNewPasswordChange} />
                    <span className="form-error">{this.state.errors["newPassword"]}</span>
                </div>
                <div className="form-group">
                    <label class="control-label">Confirm New Password</label>
                    <TextField type="password" className="form-control"
                        value={this.state.confirmPass}
                        onChange={this.handleConfirmPassChange} />
                    <span className="form-error">{this.state.errors["confirmPass"]}</span>
                </div>
                <div className="m-t-30">
                    <PrimaryButton className="btn-primary" onClick={(e) => this.handleSubmit(e)} text="Update" />
                </div>
            </form>
        );
    }
}
